import Typography from './Typography';
import cx from 'classnames';
import { ReactComponent as AddCircleIcon } from 'assets/images/icons/svgs/add-circle.svg';
import Currency from 'components/Currency/Currency';

// Image assets from Figma (valid for 7 days)
const imgLogo =
  'https://www.figma.com/api/mcp/asset/d29b2413-7df7-444c-90b3-d8e70341fbe8';
const imgLocationIcon =
  'https://www.figma.com/api/mcp/asset/bbd5a98f-5aae-4a82-bcbd-b96adfb93fd4';

const CharityListItem = ({ charity, onClick, amount, className = '' }) => {
  const charityName = charity?.name || 'One Tree Planted';
  const location = charity?.location || 'Alexandria, VA';

  return (
    <a
      href="#"
      onClick={(e) => {
        e.preventDefault();
        if (onClick) {
          onClick(charity);
        }
      }}
      className={cx(
        'border border-[rgba(0,0,0,0)] border-solid content-stretch cursor-pointer flex gap-[16px] items-center p-[17px] relative rounded-[24px] shadow-[0px_2px_8px_0px_rgba(0,0,0,0.04)] w-full',
        className,
        {
          'bg-white': !amount,
          'bg-[#F3F4F6]': amount,
        },
      )}
      data-name="Background+Border+Shadow"
      data-node-id="953:8811"
    >
      {/* Logo Section */}
      <div
        className="bg-[#dbeafe] border border-[#f3f4f6] border-solid relative rounded-[9999px] shrink-0 size-[56px]"
        data-name="Background+Border"
        data-node-id="953:8812"
      >
        <div className="bg-clip-padding border-0 border-[transparent] border-solid content-stretch flex items-center justify-center overflow-clip p-px relative rounded-[inherit] size-full">
          <div
            className="bg-white relative rounded-[16px] shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)] shrink-0 size-[56px]"
            data-name="Background+Shadow"
            data-node-id="953:8813"
          >
            <div className="bg-clip-padding border-0 border-[transparent] border-solid content-stretch flex items-center justify-center pb-[12.5px] pt-[11.5px] relative size-full">
              <div
                className="content-stretch flex flex-col items-start relative shrink-0"
                data-name="Container"
                data-node-id="953:8814"
              >
                <div className="flex items-center justify-center relative shrink-0">
                  <div className="-scale-y-100 flex-none">
                    <div
                      className="h-[58px] relative w-[48px]"
                      data-name="Icon"
                      data-node-id="953:8815"
                    >
                      <img
                        alt={charityName}
                        className="block max-w-none size-full"
                        src={imgLogo}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Text Content Section */}
      <div
        className="flex-[1_0_0] min-h-px min-w-px relative"
        data-name="Container"
        data-node-id="953:8817"
      >
        <div className="bg-clip-padding border-0 border-[transparent] border-solid content-stretch flex flex-col items-start pb-[0.5px] relative w-full">
          <div
            className="content-stretch flex flex-col items-start mb-[-0.5px] overflow-clip relative shrink-0 w-full"
            data-name="Heading 3"
            data-node-id="953:8818"
          >
            <Typography
              weight="bold"
              className="text-[#1e2b4d] text-[16px] text-left leading-[16px]"
              data-node-id="953:8819"
            >
              {charityName}
            </Typography>
          </div>
          <div
            className="content-stretch flex gap-[4px] h-[24px] items-center mb-[-0.5px] overflow-clip relative shrink-0 w-full"
            data-name="Container"
            data-node-id="953:8820"
          >
            <div
              className="content-stretch flex flex-col items-start relative shrink-0"
              data-name="Container"
              data-node-id="953:8821"
            >
              <div className="flex items-center justify-center relative shrink-0">
                <div className="-scale-y-100 flex-none">
                  <div
                    className="relative size-[10px]"
                    data-name="Icon"
                    data-node-id="953:8822"
                  >
                    <img
                      alt="Location"
                      className="block max-w-none size-full"
                      src={imgLocationIcon}
                    />
                  </div>
                </div>
              </div>
            </div>
            <Typography
              weight="medium"
              className="text-[#6b7280] text-[12px] text-left leading-[16px] whitespace-nowrap"
              data-node-id="953:8824"
            >
              {location}
            </Typography>
          </div>
        </div>
      </div>

      {amount ? (
        <Typography weight="bold" className="text-[20px]">
          <Currency amount={amount} />
        </Typography>
      ) : (
        <div
          className="relative rounded-[9999px] shrink-0 size-[40px] cursor-pointer text-[#1E2B4D]"
          data-name="Button"
          data-node-id="953:8825"
          onClick={(e) => {
            e.stopPropagation();
            if (onClick) {
              onClick(charity);
            }
          }}
        >
          <AddCircleIcon />
        </div>
      )}
    </a>
  );
};

export default CharityListItem;
